import React from 'react';
import { TrackedLink } from 'components/common/TrackedLink';
import { useWorkspacePath } from 'pages/workspaces/useWorkspace';
import { basePaths } from 'app-constants';
import { LinkHelperProps } from './index';
import { useTabbableClick } from './useTabbableClick';
import { useQueryAndHash } from './useQueryAndHash';

interface CaseLinkProps extends LinkHelperProps {
  judicataId: string;
  citator?: boolean;
}

export function useCasePath(
  judicataId: string,
  citator?: boolean,
  query?: string,
  hash?: string,
) {
  const workspacePath = useWorkspacePath();

  const path = React.useMemo(() => {
    const parts = [basePaths.cases, judicataId];
    if (citator) {
      parts.push('citator');
    }

    return workspacePath + parts.filter(Boolean).join('/');
  }, [judicataId, citator, workspacePath]);

  return useQueryAndHash(path, query, hash);
}

export function CaseLink({
  judicataId,
  to,
  query,
  hash,
  citator,
  tabbable,
  onClick,
  ...props
}: CaseLinkProps) {
  const path = useCasePath(judicataId, citator, query, hash);
  const handleClick = useTabbableClick(path.pathname, tabbable, onClick);

  return <TrackedLink to={to ? to : path} onClick={handleClick} {...props} />;
}
